import { IKnmAccessLevel } from '../../../APIPackage/CatalogsModule/interfaces/IKnmAccessLevel';
import { IKnmAccessLevelSelectOption } from '../interfaces/IKnmAccessLevelSelectOption';

export function createKnmAccessLevelSelectOption(accessLevel: IKnmAccessLevel): IKnmAccessLevelSelectOption {
  return {
    ...accessLevel,
    label: accessLevel.name,
    value: accessLevel.id,
  };
}
